export const GASLESS_DISPLAY_SOL = 0.0323;

const SOL_FEE_FORMATTER = new Intl.NumberFormat("en-US", {
	maximumFractionDigits: 9,
	minimumFractionDigits: 0,
});

export function formatGaslessFeeSol(feeSol: number | undefined): string {
	const displayFee = feeSol !== undefined && feeSol > 0 ? feeSol : GASLESS_DISPLAY_SOL;
	return `~${SOL_FEE_FORMATTER.format(displayFee)} SOL`;
}
